import React from 'react';
import PropTypes from 'prop-types';
var AlertComponent = function (_a) {
    var name = _a.name, isShown = _a.isShown, level = _a.level, hide = _a.hide, children = _a.children;
    return (isShown
        && (React.createElement("div", { className: 'alert alert-' + level + ' alert-' + name },
            typeof hide === 'function'
                && (React.createElement("button", { type: "button", className: "close", "aria-label": "Schlie\u00DFen", onClick: hide },
                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
            children)));
};
AlertComponent.propTypes = {
    name: PropTypes.string.isRequired,
    level: PropTypes.string,
    children: PropTypes.node.isRequired,
    isShown: PropTypes.bool.isRequired,
    hide: PropTypes.func
};
export default AlertComponent;
